<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" clearable  v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="买家ID">
          <el-input size="small" style="width:100px" clearable  v-model="searchForm.user_id" placeholder="买家ID"></el-input>
        </el-form-item>
        <el-form-item label="买家昵称">
          <el-input size="small" style="width:150px" clearable  v-model="searchForm.nickname" placeholder="买家昵称"></el-input>
        </el-form-item>
        <el-form-item label="收货人">
          <el-input size="small" style="width:120px" clearable  v-model="searchForm.address" placeholder="姓名或手机"></el-input>
        </el-form-item>

        <el-form-item label="课程手机号">
          <el-input size="small" style="width:120px" clearable  v-model="searchForm.mobile" placeholder="课程手机号"></el-input>
        </el-form-item>

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>

      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
         <!-- <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane :label="'待发货(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane :label="'售后订单(' + order_count.apply_cancle + ')'" name="apply_cancle"></el-tab-pane>
          <el-tab-pane :label="'待收货(' + order_count.received + ')'" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane> -->
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="订单信息" width="400">
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="state-text" :class="{'state-text-red':scope.row.order_source != 10}">{{scope.row.order_source_text}}</span>

                <span class="c_main">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
                <span class="pl16">备注信息：{{ scope.row.remark }}</span>
              </div>
              <template v-else>
                <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
                  <div class="pic"><img v-img-url="item.image.file_path" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>

                    <div class="gray9" v-if="item.supplier_id">供应商：{{ item.supplier.company_name }}（ID：{{ item.supplier_id }}）</div>

                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                    <div class="orange" v-if="item.refund">
                      {{ item.refund.type.text }}-{{ item.refund.status.text }}
                      <span v-if="item.refund.refund_money">退款金额：{{ item.refund.refund_money }}</span>
                    </div>

                    <div class="orange">结算类型：{{item.ml_type==1?'正常结算':'特殊定向'}}</div>
                    <div class="orange">{{ item.is_agri==1?"农产品":"" }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.product_price }}</div>
                    <div class="gray3">x{{ item.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
              <p class="orange" v-if="scope.row.refund_money>0">
                <span v-if="checkMoney(scope.row.refund_money,scope.row.pay_price)">部分退款</span>
                <span v-else>全额退款</span>
                ￥{{ scope.row.refund_money }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div v-if="scope.row.user && scope.row.user.nickName">{{ scope.row.user.nickName }}</div>
              <div class="gray9" v-if="scope.row.user && scope.row.user.user_id">ID：({{ scope.row.user.user_id }})</div>

              <div class="gray9" v-if="scope.row.referee_id">
              推荐人：
              (
                {{ scope.row.referee.nickName }},{{ scope.row.referee_id }}
              )</div>

               <div class="gray9">
              买家留言：{{ scope.row.buyer_remark }}
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.state_text }}
              <p v-if="scope.row.erp_status==1 ">
                <el-tag size="mini">已同步聚水潭</el-tag>
              </p>
              <p v-if="scope.row.trade_status==1 ">
                <el-tag size="mini">已同步erp</el-tag>
              </p>
              <p v-if="scope.row.trade_status==-1 ">
                <el-tag size="mini">同步erp失败</el-tag>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_type.text" label="配送方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{scope.row.user.mobile}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="current_time" label="配送时间" v-if="show_Distribution == true"></el-table-column>
          <el-table-column prop="is_comment" label="评价" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span v-if="scope.row.is_comment == 0">未评价</span>
              <span v-else>已评价</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detailq'">订单详情</el-button>

              <el-button
                v-if="scope.row.pay_status.value == 20
                && scope.row.delivery_status.value == 20"
                @click="editClick(scope.row,'track')"
                type="text"
                size="small"
                v-auth="'/order/express/trackq'"
              >
                物流轨迹
              </el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>


    <Track v-if="open_dialog.track" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'track')"></Track>

  </div>
</template>

<script>
import OrderApi from '@/api/order.js';
import qs from 'qs';
import Track from './dialog/Trackq.vue';
export default {
  components: {
    /*物流轨迹*/
    Track
  },
  data() {
    return {
      /*是否打开批量发货弹窗*/
      open_add: false,
      /*是否打开订单导出弹窗*/

      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        order_no: "",
        user_id: "",
        nickname:"",
        address: "",
        mobile:""
      },
      /*付款方式*/
      payType: [],
      // 结算类型
      mlType:[],
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*分类列表*/
      categoryList: [],
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        apply_cancle:0,
      },
      open_dialog: {
        /*快速发货*/
        express: false,
        remark: false,
         /*物流轨迹*/
        track: false,
        /*订单核销*/
        extract:false,
        /*订单导出*/
        fileExport:false,
        /*付款凭证支付*/
        pay_image:false,
        },

      dataModel:{},
      /*权限检测*/
      show_Distribution: false,
    };
  },
  created() {
    let tabs = this.$db.getRouteField(this, 'tabs');
    let page = this.$db.getRouteField(this, 'page');
    let ordersearchForm = this.$db.getRouteField(this, 'ordersearchForm');
    if (tabs) this.activeName = tabs;
    if (page) this.curPage = page;
    if (ordersearchForm) this.searchForm = ordersearchForm;
    /*权限检测*/
    if(this.$filter.isAuth('/setting/distribution/dialog/distribution'))  this.show_Distribution = true;
    /*获取列表*/
    this.getData();

  },
  methods: {
    checkMoney(num1,num2){
      if(parseFloat(num1)<parseFloat(num2)){
        return true;
      }
      return false;
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.$db.setRoute(this, {'page': val});
      let self = this;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      this.$db.setRoute(this, {'tabs': tab.name, 'page': 1});
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      self.loading = true;

      //订单号，买家ID, 收货人 必须又一个搜索才可以搜索
      if(!(Params.order_no.trim()+Params.user_id.trim()+Params.nickname.trim()+Params.address.trim())){
         self.tableData.data = [];
         self.totalDataNumber = 0;
          self.order_count = 0;
         self.loading = false;
        return;
      }

      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;

      OrderApi.orderlistq(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              remark: item.remark,
              buyer_remark: item.buyer_remark,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              is_top_row: true
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;

          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.payType = res.data.pay_type;
          self.mlType = res.data.ml_type;
          self.shopList = res.data.shop_list;
          self.categoryList = res.data.catgory;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detailq',
        query: {
          order_id: params
        }
      });
    },

    /*打开编辑*/
    editClick(data,type) {
      if (type == 'express') {
        for (var i = data.product.length - 1; i >= 0; i--) {
          if (data.product[i].refund && data.product[i].refund.status.value == 0) {
            this.$message('售后未完成，不能去发货');
            return false;
          }
        }
      }
      this.dataModel = data;
      this.open_dialog[type] = true;
    },
    /*订单导出*/
    editeClick() {
      this.open_dialog.fileExport = true;
    },

    /*搜索查询*/
    onSubmit() {
      this.$db.setRoute(this, {'page': 1});
      this.$db.setRoute(this, {'ordersearchForm': this.searchForm});
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        this.getData();

      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        this.getData();
      }

      if (f == 'track') {
        this.open_dialog.track = e.openDialog;
        this.getData();
      }

    },
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .d-s-c{
  display: flex;
	justify-content: flex-start;
	align-items: center;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/query.vue